import i18n from '@/api/i18n/i18n';

const sourceDict = {
  1000: i18n.t('pages.sourceDict.unknown'),
  1001: 'Usb',
  1002: i18n.t('pages.sourceDict.cloud_disks'),
  1003: 'Drobpox',
  1004: 'GoogleDrive',
  1005: 'YandexDisk',
  1006: 'CloudMailRu',
  1007: 'OneDrive',
  1008: 'Local directory',
  1009: 'Remote',
};

export const source = (val) => sourceDict[val];

const actionDict = {
  33: i18n.t('pages.actionDict.copyingFile'),
  34: i18n.t('pages.actionDict.modifyingFile'),
};

export const action = (val) => actionDict[val];

const availableDict = {
  0: i18n.t('pages.availableDict.copyPC'),
  1: i18n.t('pages.availableDict.copyServ'),
  2: i18n.t('pages.availableDict.noCopy'),
};

export const available = (val) => availableDict[val];
